var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"chattime",class:{oneWeekOrMore : _vm.oneWeekOrMore == true, hide: !_vm.show}},[_vm._v(_vm._s(_vm.convertedTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }